
  
  <form [formGroup]="referenceForm" (ngSubmit)="onSubmit(SaveMode.SAVE)" class="p-3">

    <!-- Applicant Info Section -->
    <!-- Applicant Details -->
  <div class="table-responsive mb-4">
    <table class="table table-bordered shadow-sm bg-white">
      <tbody>
        <tr>
          <th>Applicant</th>
          <td>{{ referenceForm.get('NameOfApplicant')?.value || '—' }}</td>
        </tr>
        <tr>
          <th>Date</th>
          <td>{{ referenceForm.get('date')?.value || '—' }}</td>
        </tr>
        <tr>
          <th>Reference By</th>
          <td>{{ referenceForm.get('NameOfPersonGivingReference')?.value || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
    <!-- Question 1 -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header bg-secondary text-white">1. How long have you known the applicant?</div>
      <div class="card-body">
        <p class="small text-muted mb-2">If you do not know the applicant personally, please get info from a Centre Team member.</p>
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <label class="form-label fw-bold">Years <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="YearsKnown"
                   [ngClass]="{'is-invalid': submitted && referenceForm.controls['YearsKnown'].invalid}">
            <div class="invalid-feedback">Required</div>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label fw-bold">In what capacity? <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="Capacity"
                   [ngClass]="{'is-invalid': submitted && referenceForm.controls['Capacity'].invalid}">
            <div class="invalid-feedback">Required</div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Question 2 -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header bg-secondary text-white">2. Does the applicant go to the centre? <span class="text-danger">*</span></div>
      <div class="card-body">
        <div class="d-flex flex-column flex-md-row gap-3 align-items-start">
          <div class="form-check">
            <input type="radio" id="centerYes" class="form-check-input" formControlName="CurrentlyParticipatingCenter" [value]="true">
            <label for="centerYes" class="form-check-label">Yes</label>
          </div>
          <div *ngIf="referenceForm.get('CurrentlyParticipatingCenter')?.value === true" class="flex-grow-1">
            <label class="form-label fw-bold">How many times per month? <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="CenterAttendanceFrequency"
                   [ngClass]="{'is-invalid': submitted && referenceForm.controls['CenterAttendanceFrequency'].invalid}">
            <div class="invalid-feedback">Required</div>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row gap-3 mt-2 align-items-start">
          <div class="form-check">
            <input type="radio" id="centerNo" class="form-check-input" formControlName="CurrentlyParticipatingCenter" [value]="false">
            <label for="centerNo" class="form-check-label">No</label>
          </div>
          <div *ngIf="referenceForm.get('CurrentlyParticipatingCenter')?.value === false" class="flex-grow-1">
            <label class="form-label fw-bold">Do you know why? <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="ReasonForNotGoing"
                   [ngClass]="{'is-invalid': submitted && referenceForm.controls['ReasonForNotGoing'].invalid}">
            <div class="invalid-feedback">Required</div>
          </div>
        </div>
        <div *ngIf="submitted && referenceForm.controls['CurrentlyParticipatingCenter'].invalid" class="text-danger small mt-2">
          Required
        </div>
      </div>
    </div>
  
    <!-- Question 3 -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header bg-secondary text-white">3. Has the applicant participated in a Siddha Yoga Shaktipat intensive in the last 5 years? <span class="text-danger">*</span></div>
      <div class="card-body">
        <div class="d-flex flex-column flex-md-row gap-3 align-items-start">
          <div class="form-check">
            <input type="radio" id="intYes" class="form-check-input" formControlName="ParticipatedInShaktipatIntensive" [value]="true">
            <label for="intYes" class="form-check-label">Yes</label>
          </div>
          <div *ngIf="referenceForm.get('ParticipatedInShaktipatIntensive')?.value === true" class="flex-grow-1">
            <label class="form-label fw-bold">Year <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="LastIntensiveYear"
                   [ngClass]="{'is-invalid': submitted && referenceForm.controls['LastIntensiveYear'].invalid}">
            <div class="invalid-feedback">Required</div>
          </div>
        </div>
        <div class="form-check mt-2">
          <input type="radio" id="intNo" class="form-check-input" formControlName="ParticipatedInShaktipatIntensive" [value]="false">
          <label for="intNo" class="form-check-label">No / Don't Know</label>
        </div>
        <div *ngIf="submitted && referenceForm.controls['ParticipatedInShaktipatIntensive'].invalid" class="text-danger small mt-2">
          Required
        </div>
      </div>
    </div>
  
    <!-- Question 4 (Seva) -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header bg-secondary text-white">4. Does the applicant offer any seva at the centre? <span class="text-danger">*</span></div>
      <div class="card-body">
        <div class="d-flex gap-3 mb-2">
          <div class="form-check">
            <input type="radio" id="sevaYes" class="form-check-input" formControlName="OffersSeva" [value]="true">
            <label for="sevaYes" class="form-check-label">Yes</label>
          </div>
          <div class="form-check">
            <input type="radio" id="sevaNo" class="form-check-input" formControlName="OffersSeva" [value]="false">
            <label for="sevaNo" class="form-check-label">No</label>
          </div>
        </div>
        <div *ngIf="submitted && referenceForm.controls['OffersSeva'].invalid" class="text-danger small mb-3">
          Required
        </div>
  
        <!-- Seva Details -->
        <div *ngIf="referenceForm.get('OffersSeva')?.value === true" [formGroup]="SevaForm" class="border p-3 rounded bg-light mb-3">
          <div class="row g-3">
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-bold">Seva <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="seva"
                     [ngClass]="{'is-invalid': submitted && SevaForm.controls['seva'].invalid}">
              <div class="invalid-feedback">Required</div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-bold">Since when <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="SevaSinceWhen"
                     [ngClass]="{'is-invalid': submitted && SevaForm.controls['SevaSinceWhen'].invalid}">
              <div class="invalid-feedback">Required</div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-bold">How Often <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="SevaHowOften"
                     [ngClass]="{'is-invalid': submitted && SevaForm.controls['SevaHowOften'].invalid}">
              <div class="invalid-feedback">Required</div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-bold">Name of supervisor <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="SupervisorName"
                     [ngClass]="{'is-invalid': submitted && SevaForm.controls['SupervisorName'].invalid}">
              <div class="invalid-feedback">Required</div>
            </div>
          </div>
          <button type="button" class="btn btn-primary btn-sm mt-3" (click)="addSeva()">+ Add Seva</button>
        </div>
  
        <div *ngIf="referenceForm.get('OffersSeva')?.value === false" class="mb-3">
          <label class="form-label fw-bold">If NO, why? <span class="text-danger">*</span></label>
          <input class="form-control" formControlName="ReasonForNotOfferingSeva"
                 [ngClass]="{'is-invalid': submitted && referenceForm.controls['ReasonForNotOfferingSeva'].invalid}">
          <div class="invalid-feedback">Required</div>
        </div>
    
    
    


             <!-- Seva Details Table -->

             <div *ngIf="referenceForm.get('OffersSeva')?.value === true">


              <div *ngIf="sevaListArray.length > 0" class="table-responsive mt-3">
                <table class="table table-bordered table-striped align-middle">
                  <thead class="table-light">
                    <tr>
                      <th>Seva</th>
                      <th>Since When</th>
                      <th>How Often</th>
                      <th>Supervisor Name</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let seva of sevaListArray; let i = index">
                      <td>{{ seva.seva }}</td>
                      <td>{{ seva.SevaSinceWhen | date:'dd-MM-yyyy' }}</td>
                      <td>{{ seva.SevaHowOften }}</td>
                      <td>{{ seva.SupervisorName }}</td>
                      <td class="text-center">
                        <button type="button" class="btn btn-sm btn-danger" (click)="removeSeva(i)">Remove</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              

             </div>




    
      </div>



 






    </div>
  
    <!-- Question 5 -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header bg-secondary text-white">5. Are you aware of any physical limitations?</div>
      <div class="card-body">
        <div class="d-flex gap-3 mb-2">
          <div class="form-check">
            <input type="radio" id="physYes" class="form-check-input" formControlName="PhysicalLimitations" [value]="true">
            <label for="physYes" class="form-check-label">Yes</label>
          </div>
          <div class="form-check">
            <input type="radio" id="physNo" class="form-check-input" formControlName="PhysicalLimitations" [value]="false">
            <label for="physNo" class="form-check-label">No</label>
          </div>
        </div>
        <div *ngIf="submitted && referenceForm.controls['PhysicalLimitations'].invalid" class="text-danger small mb-2">
          Required
        </div>
        <div *ngIf="referenceForm.get('PhysicalLimitations')?.value === true" class="mb-3">
          <label class="form-label fw-bold">Comments:</label>
          <input class="form-control" formControlName="PhysicalLimitationsComments">
        </div>
      </div>
    </div>
  
    <!-- Question 6 & 7 combined -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header bg-secondary text-white">6. & 7. Recommendations & Additional Comments</div>
      <div class="card-body">
        <div class="row g-3 mb-3">
          <div class="col-12 col-md-6">
            <label class="form-label fw-bold">Visiting Sevite <span class="text-danger">*</span></label>
            <div class="d-flex gap-3 mb-2">
              <div class="form-check">
                <input type="radio" id="visitingSeviteYes" class="form-check-input" formControlName="RecommendVisitingSevite" [value]="true">
                <label for="visitingSeviteYes" class="form-check-label">Yes</label>
              </div>
              <div class="form-check">
                <input type="radio" id="visitingSeviteNo" class="form-check-input" formControlName="RecommendVisitingSevite" [value]="false">
                <label for="visitingSeviteNo" class="form-check-label">No</label>
              </div>
            </div>
            <div *ngIf="submitted && referenceForm.controls['RecommendVisitingSevite'].invalid" class="text-danger small mb-2">
              Required
            </div>
            <div *ngIf="referenceForm.get('RecommendVisitingSevite')?.value === false" class="mt-2">
              <label class="form-label fw-bold">If NO, why? <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="ReasonNotRecommendVisitingSevite"
                     [ngClass]="{'is-invalid': submitted && referenceForm.controls['ReasonNotRecommendVisitingSevite'].invalid}">
              <div class="invalid-feedback">Required</div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label fw-bold">Retreat <span class="text-danger">*</span></label>
            <div class="d-flex gap-3 mb-2">
              <div class="form-check">
                <input type="radio" id="retreatYes" class="form-check-input" formControlName="RecommendRetreat" [value]="true">
                <label for="retreatYes" class="form-check-label">Yes</label>
              </div>
              <div class="form-check">
                <input type="radio" id="retreatNo" class="form-check-input" formControlName="RecommendRetreat" [value]="false">
                <label for="retreatNo" class="form-check-label">No</label>
              </div>
            </div>
            <div *ngIf="submitted && referenceForm.controls['RecommendRetreat'].invalid" class="text-danger small mb-2">
              Required
            </div>
            <div *ngIf="referenceForm.get('RecommendRetreat')?.value === false" class="mt-2">
              <label class="form-label fw-bold">If NO, why? <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="ReasonNotRecommendRetreat"
                     [ngClass]="{'is-invalid': submitted && referenceForm.controls['ReasonNotRecommendRetreat'].invalid}">
              <div class="invalid-feedback">Required</div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label fw-bold">Additional comments <span class="text-danger">*</span></label>
          <textarea class="form-control" formControlName="AdditionalComments" rows="3"
                    [ngClass]="{'is-invalid': submitted && referenceForm.controls['AdditionalComments'].invalid}"></textarea>
          <div class="invalid-feedback">Required</div>
        </div>
      </div>
    </div>
  


    <!-- Buttons start -->
    <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive mt-3">
      <button type="submit" class="btn nextbtn">
        <i class="fas fa-check mr-2"></i>Submit
      </button>
    </div>
    <!-- Buttons ends -->
  </form>
  





